/**
 * Darkroom Booking System Constants
 * Centralized configuration for property names, selectors, URLs, and defaults
 */

const DARKROOM = {
  // ===== Session Storage Keys =====
  STORAGE_KEY: 'negdev:booking',
  
  // ===== DOM Selectors =====
  SELECTORS: {
    FORM: 'form[data-type="add-to-cart-form"]',
    SUBMIT_BUTTON: '.product-form__submit[name="add"]',
    ERROR_WRAPPER: '.product-form__error-message-wrapper',
    ERROR_MESSAGE: '.product-form__error-message',
    QUANTITY_INPUT: '[name="quantity"]',
    QUANTITY_BLOCK: '.product-form__quantity',
    QUANTITY_FORM_ATTR: '[form="{formId}"]',
    VARIANT_RADIOS: 'variant-radios[data-section]',
    VARIANT_SELECTS: 'variant-selects[data-section]',
    VARIANT_JSON: 'script[type="application/json"]',
    SPINNER: '.loading-overlay__spinner',
    PRODUCT_ID_INPUT: 'input[name="id"]',
    TRIGGER_BUTTON: '#open-darkroom'
  },

  // ===== Booking Property Names (Shopify line item properties) =====
  // These are persisted to the cart and passed to fulfillment/webhooks
  PROPERTIES: {
    // Visible property shown in cart (not underscore-prefixed)
    LABEL: 'Date',
    // Hidden properties (underscore-prefixed so Shopify hides them)
    START: '_Booking Start',
    END: '_Booking End',
    SCOPE: '_Booking Scope',
    HOURS: '_Booking Hours',
    // Google-event specific properties
    EVENT_ID: '_Event ID',
    EVENT_TITLE: '_Event Title',
    MAX_QUANTITY: '_Max Quantity',
    PARTICIPANT_COUNT: '_Participant Count'
  },

  // ===== Configuration Keys =====
  // Window variables populated by Shopify theme (main-product.liquid)
  METAFIELDS: {
    SHOW_AVAILABILITY_PREVIEW: 'product_metafields_show_availability_preview',
    GOOGLE_EVENT_NAME: 'product_metafields_google_event_name',
    MAX_QUANTITY: 'product_metafields_max_quantity'
  },

  // ===== Default Scope =====
  DEFAULT_SCOPE: 'supervised',
  SCOPE: {
    SUPERVISED: 'supervised',
    UNSUPERVISED: 'unsupervised',
    GOOGLE_EVENT: 'google-event'
  },

  // ===== Event Listener Names (custom events) =====
  EVENTS: {
    BOOKING_SELECTED: 'negdev:booking:selected',
    CALENDAR_SELECT_RANGE: 'negdev:calendar/select-range',
    CALENDAR_BOOK: 'negdev:calendar/book'
  },

  // ===== Embed Configuration =====
  EMBED: {
    // CDN URL for the calendar embed script
    SCRIPT_URL: 'https://docs.negativedevelopment.co.uk/NegDevCalendar/embed.js',
    SCRIPT_VERSION: '20260329',
    // Base URL for DarkroomCalendar.init() - must match embed script origin
    BASE_URL: 'https://docs.negativedevelopment.co.uk/NegDevCalendar/',
    // Origin for postMessage security validation
    IFRAME_ORIGIN: 'https://docs.negativedevelopment.co.uk'
  },

  // ===== Webhook / API Configuration =====
  WEBHOOK_URL: 'https://shopify-gcal-webhook-3z64u2cz5q-uc.a.run.app/api',

  // ===== Defaults =====
  DEFAULTS: {
    ERROR_MESSAGE: 'Please select a start and end time.',
    ERROR_MESSAGE_SUBMIT: 'Please select a start and end time before adding to basket.',
    CURRENCY: 'GBP',
    // Price in cents for unsupervised scope (if not overridden by variant pricing)
    UNSUPERVISED_PRICE_CENTS: 1500
  },

  // ===== Console Logging Prefixes =====
  LOG: {
    PREFIX: '[Darkroom]',
    SCOPE_DETECTION: '[Darkroom] Scope detection:',
    SCOPE_SET: '[Darkroom] Set scope',
    SCOPE_ERROR: '[Darkroom] Error during scope detection:',
    INIT: '[Darkroom] Initializing DarkroomCalendar with:',
    GET_PRICE: '[Darkroom] getPrice',
    GET_PRICE_SHOPIFY_ANALYTICS: '[Darkroom] getPrice via ShopifyAnalytics',
    GET_PRICE_VARIANTS_JSON: '[Darkroom] getPrice via variants JSON',
    GET_PRICE_NO_FORM: '[Darkroom] getPrice: no form',
    GET_PRICE_NO_VARIANTS: '[Darkroom] getPrice: no variants JSON',
    GET_PRICE_ERROR: '[Darkroom] getPrice error',
    BOOKING_PAYLOAD: '[Darkroom] Received booking payload from embed:',
    INIT_FAILED: 'DarkroomCalendar init failed'
  }
};
